export enum PdfTemplates {
    rhopointInstruments = "rhopointInstruments",
    detailometer = "detailometer"
}
